import { MutationTree } from 'vuex';
import { PushApplicationState } from './types';

export const mutations: MutationTree<PushApplicationState> = {
  setPushApplications: (state, data) => {
    state.pushApplications = data
  },
  setPushApplication: (state, data) => {
    state.pushApplication = data
  },

  setPushPlatforms: (state, data: any[]) => {
    let platforms: string[] = [];
    data.forEach(i => {
      platforms.push(i.platform);
    });
    state.pushPlatforms = platforms;
  },
  setPushOS: (state, data) => {
    state.pushOS = data
  },
}
